import { schema } from 'normalizr';

/* Schemas: Here you can stablish the relations between each entity on the redux store. This is used to normalize api responses */

// Tracker Logs
export const trackerLogSchema = new schema.Entity('trackerLog');
export const trackerLogListSchema = new schema.Array(trackerLogSchema);

// Vehicles
export const vehicleSchema = new schema.Entity(
  'vehicles',
  {},
  {
    idAttribute: 'number_plate',
  }
);

export const vehicleListSchema = new schema.Array(vehicleSchema);

// Transactions by ChargePoint and Timestamp
export const transactionsByTimestampSchema = new schema.Entity(
  'transactionsByTimestamp',
  {},
  {
    idAttribute: 'id',
  }
);
export const transactionByTimestampListSchema = new schema.Array(transactionsByTimestampSchema);

// Transactions
export const transactionSchema = new schema.Entity(
  'transactions',
  {
    vehicle: vehicleSchema,
  },
  {
    idAttribute: 'connector',
  }
);
export const transactionListSchema = new schema.Array(transactionSchema);

// Charging Profiles
export const chargingProfileSchema = new schema.Entity('charging_profiles');
export const chargingProfileListSchema = new schema.Array(chargingProfileSchema);

// Connectors
export const connectorSchema = new schema.Entity('connectors', {
  transaction: transactionSchema,
  charging_profiles: [chargingProfileSchema],
});
export const connectorListSchema = new schema.Array(connectorSchema);

// Charge Points
export const chargePointSchema = new schema.Entity('charge_points', {
  connectors: [connectorSchema],
});
export const chargePointListSchema = new schema.Array(chargePointSchema);

// Grid Connections
export const gridConnectionSchema = new schema.Entity('grid_connections', {
  charge_points: [chargePointSchema],
});
export const gridConnectionListSchema = new schema.Array(gridConnectionSchema);

// Assets
export const assetSchema = new schema.Entity('assets', {
  grid_connections: [gridConnectionSchema],
});
export const assetListSchema = new schema.Array(assetSchema);
